// imports from npm
import React, { Component } from "react";
import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import {
  withStyles,
  WithStyles,
  createStyles,
  withWidth,
  DialogContent,
  DialogActions,
  Button,
  Theme,
  DialogContentText
} from "@material-ui/core";
import { Dialog } from "@material-ui/core";
// import local files
import { StoreState } from "src/external/store/storeState";
import FeedbackCollectionForm from "./FeedbackCollectionForm";
import LoadingCard from "src/internal/components/Common/LoadingCard";
import { getAppointmentSurveyForAppointment, patchAppointmentSurvey } from "src/external/actions/surveyActions";
import { AppointmentSurveyDto } from "src/external/types/appointmentSurvey";
import { layoutBreakpoint } from "src/globalCssVars";
import { WithWidth, isWidthDown } from "@material-ui/core/withWidth";
import { RouteComponentProps } from "react-router";

interface AppointmentSurveyPageDispatchProps {
  getAppointmentSurveyForAppointment: (apptId: number) => Promise<boolean>;
  submitFeedback: (apptSurvey: AppointmentSurveyDto) => Promise<boolean>;
}

interface AppointmentSurveyPageReduxProps {
  appointmentSurvey: AppointmentSurveyDto;
}

interface AppointmentSurveyPageState {
  open: boolean;
  disabled: boolean;
  apptSurveyLoaded: boolean;
  previoulsySubmitted: boolean;
}

interface AppointmentSurveyRouteParams {
  apptId: number;
}

interface AppointmentSurveyPageProps
  extends AppointmentSurveyPageReduxProps,
    AppointmentSurveyPageDispatchProps,
    RouteComponentProps<AppointmentSurveyRouteParams>,
    WithWidth,
    WithStyles<typeof styles> {}

class AppointmentSurveyPage extends Component<AppointmentSurveyPageProps, AppointmentSurveyPageState> {
  constructor(props: AppointmentSurveyPageProps) {
    super(props);
    this.state = {
      open: false,
      apptSurveyLoaded: false,
      previoulsySubmitted: false,
      disabled: false
    };
  }

  componentDidMount = async () => {
    this.setState({ disabled: true });
    try {
      await this.props.getAppointmentSurveyForAppointment(this.props.match.params.apptId);
      if (!this.state.apptSurveyLoaded && this.props.appointmentSurvey && this.props.appointmentSurvey.id) {
        this.setState({ apptSurveyLoaded: true });
      } else {
        this.setState({
          disabled: true,
          previoulsySubmitted: true,
          open: true
        });
      }
    } finally {
      this.setState({ disabled: false });
    }
  };

  handleSubmitFeedback = async (feedback: AppointmentSurveyDto) => {
    let submitSucceeded = await this.props.submitFeedback(feedback);
    if (submitSucceeded) {
      this.props.history.push("/");
    }
  };

  handleClose = () => {
    this.setState({ open: false });
    this.props.history.push("/");
  };

  render() {
    const { width, classes } = this.props;
    const { previoulsySubmitted } = this.state;
    const isMobile = isWidthDown(layoutBreakpoint, width);
    if (previoulsySubmitted) {
      return (
        <Dialog open={this.state.open} onClose={this.handleClose}>
          <DialogContent>
            <DialogContentText>Feedback has already been submitted for this appointment.</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      );
    } else {
      return this.state.apptSurveyLoaded ? (
        <div className={classes.root}>
          <FeedbackCollectionForm
            survey={this.props.appointmentSurvey}
            isMobile={isMobile}
            onSave={this.handleSubmitFeedback}
          />
        </div>
      ) : (
        <LoadingCard title="Loading Survey" />
      );
    }
  }
}

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      justifyContent: "start",
      padding: `${theme.spacing.unit * 2}rem 0 ${theme.spacing.unit * 2}rem 0`
    }
  });

const mapStateToProps = (state: StoreState): AppointmentSurveyPageReduxProps => {
  return {
    appointmentSurvey: state.appointmentSurvey
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<StoreState, void, AnyAction>
): AppointmentSurveyPageDispatchProps => {
  return {
    getAppointmentSurveyForAppointment: async (apptId: number) =>
      await dispatch(await getAppointmentSurveyForAppointment(apptId)),
    submitFeedback: async (feedback: AppointmentSurveyDto) => await dispatch(await patchAppointmentSurvey(feedback))
  };
};

export default withStyles(styles)(
  withWidth()(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(AppointmentSurveyPage)
  )
);
